import TopBar from 'components/Layout/TopBar';
import useAuthz from 'hooks/useAuthz';
import React, {useEffect} from 'react';
import {useAlert} from 'react-alert';
import {useNavigate} from 'react-router';
import ModuleAdmin from './ModuleAdmin';
import {
  faChartPie,
  faCoins,
  faDesktop,
  faMapLocationDot,
  faUsers,
  faUserSlash,
  faCog,
  faEuroSign,
} from '@fortawesome/free-solid-svg-icons';

const administrationStyle = {
  row: {
    alignItems: 'center', alignContent: 'center', height: '90%'
  }
}

const Administration = (props) => {
  const [authz, user, profil] = useAuthz();
  const navigate = useNavigate();
  const alert = useAlert();

  useEffect(() => {
    if (profil.profil !== 1) {
      alert.error("Vous n'êtes pas autorisé à accéder au module au panneau d'administration");
      navigate('/');
    } else {
      document.title = "TE - Panneau d'administration";
    }
  }, []);

  return (
    <div style={{height: '100%'}}>
      <TopBar title="Panneau d'administration" className='topbar-contenu' color={props.params.color}/>

      <div className='row' style={administrationStyle.row}>
        <ModuleAdmin libelle='Gestion des utilisateurs' fontAwesomePicture={faUsers} url={'/panneau-administration/utilisateur'}/>
        <ModuleAdmin libelle='Historique des actions' fontAwesomePicture={faDesktop} url={'/panneau-administration/tracing'}/>
        <ModuleAdmin libelle='Gestion des centres' fontAwesomePicture={faMapLocationDot} url={'/panneau-administration/centres'}/>
        <ModuleAdmin libelle='Grilles Tarifaires' fontAwesomePicture={faCoins} url={'/panneau-administration/grille-tarifaire'}/>
        <ModuleAdmin libelle='Blacklist' fontAwesomePicture={faUserSlash} url={'/panneau-administration/blacklist'}/>
        <ModuleAdmin libelle='Élements patrimoines' fontAwesomePicture={faMapLocationDot} url={'/panneau-administration/elements-patrimoines'}/>
        <ModuleAdmin libelle='Tiers facturés' fontAwesomePicture={faEuroSign} url={'/panneau-administration/tiers-factures'}/>
        <ModuleAdmin libelle='Statistiques' fontAwesomePicture={faChartPie} url={'/panneau-administration/statistiques'}/>
        <ModuleAdmin libelle='Paramétrage' fontAwesomePicture={faCog} url={'/panneau-administration/parametrage'}/>
      </div>
    </div>
  );
};

export default Administration;
